import 'babel-polyfill';
import 'react-app-polyfill/ie11';
import { AppContainer } from 'react-hot-loader'
import { applyMiddleware, compose, createStore } from 'redux'
import { routerMiddleware, connectRouter } from 'connected-react-router'
import { Provider } from 'react-redux'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import rootReducer from './reducers'
import api from './middleware/api';
import { history } from './history';
import ErrorBoundary from './components/shared/ErrorBoundary';

// `history` now lives in ./history so that importing a component cannot boot the application.
// Re-exported because this module used to be where it came from, and an import that quietly
// stops resolving is worse than one extra line.
export { history };

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = createStore(
  connectRouter(history)(rootReducer),
  composeEnhancer(
    applyMiddleware(
      routerMiddleware(history),
      api
    ),
  ),
)

const render = () => {
  ReactDOM.render(
    <AppContainer>
      {/* ABOVE the provider, because a boundary catches what is below it and the failure this
          was written for was in App.render itself (OVIO-7). */}
      <ErrorBoundary>
        <Provider store={store}>
          <App history={history} />
        </Provider>
      </ErrorBoundary>
    </AppContainer>,
    document.getElementById('root')
  )
}

render()

// Hot reloading
if (module.hot) {
  // Reload components
  module.hot.accept('./App', () => {
    render()
  })

  // Reload reducers
  module.hot.accept('./reducers', () => {
    store.replaceReducer(connectRouter(history)(rootReducer))
  })
}